type Args = {
  vat_code: number | null; // wanted vat category
  unit_vat_regulation: boolean; // if supplier is vat_regulation
  car: boolean; // if car is vat enabled
  project: boolean; // if project is vat enabled
  department: boolean; // if department is vat enabled
  bookkeeping_account: { // bookkeeping account to check available rate
    vat_code: number | null; // vat_code
    vat_can_be_overwritten: boolean; // is bookkeeping account allows vat enable
  } | null;
};

export default function(args: Args) {
  const result = {
    title: [] as string[],
    vat_code: null as number | null,
    editable: false
  };

  if (!args.unit_vat_regulation) result.title.push(`disabled_vat_on_unit`);
  if (!args.car) result.title.push(`disabled_vat_car`);
  if (!args.project) result.title.push(`disabled_vat_project`);
  if (!args.department) result.title.push(`disabled_vat_department`);
  const vat_enabled =
    args.unit_vat_regulation && args.car && args.project && args.department;

  if (args.bookkeeping_account && args.bookkeeping_account.vat_can_be_overwritten == false) {
    result.title.push(`disabled_vat_bookkeepingaccount`);
    if (vat_enabled) result.vat_code = args.bookkeeping_account.vat_code || null;
  } else if (vat_enabled) {
    result.vat_code = args.vat_code || null;
    result.editable = true;
  }

  return result;
};
